import * as React from "react";
import { useLocalization } from "@shared-ui/localization-context";
import { UitkSpacing } from "uitk-react-spacing";
import { UitkText } from "uitk-react-text";

interface PriceWithDiscountProps {
  packagePriceNoSavings: string;
  formattedPrice: string;
}

const PriceWithDiscount = (props: PriceWithDiscountProps) => {
  const { packagePriceNoSavings, formattedPrice } = props;
  const { formatText } = useLocalization();

  return (
    <>
      <span className="is-visually-hidden">
        {formatText("package.card.price.lockup.a11y.text", packagePriceNoSavings, formattedPrice)}
      </span>
      <UitkSpacing padding={{ inlinestart: "half" }}>
        <div aria-hidden="true">
          <UitkText inline="s" size={300}>
            {packagePriceNoSavings}
          </UitkText>
        </div>
      </UitkSpacing>
    </>
  );
};

export default PriceWithDiscount;
